import { GetterTree } from 'vuex'
import RootState from '@/store/RootState'
import StockState from './StockState';

const getters: GetterTree <StockState, RootState> = {
  getCached(state) {
    return state.cached
  },
  getTasks(state) {
    return state.tasks.list ?? [];
  },
  getColdTasks(state) {
    return state.coldTasks.list ?? [];
  },
  getTaskDetails(state) {
    return state.stockDetails;
  },
}
export default getters;
